const BigBayCityHome = () => import('Views/bigBayCity/bigBayCity-home');
const BigBayCityList = () => import('Views/bigBayCity/bigBayCity-list');
const BigBayCityDetail = () => import('Views/bigBayCity/bigBayCity-detail');

export default[
  { path: '/bigBayCity-home', component: BigBayCityHome },
  { path: '/bigBayCity-list', component: BigBayCityList },
  { path: '/bigBayCity-detail/:id', component: BigBayCityDetail },
];



// WEBPACK FOOTER //
// ./src/router/bigBayCity.js